import { OnlineOrOffline } from "modules/BookingCommon/common/interfaces"
import { HeadlineSessionDate } from "modules/BookingCommon/components/HeadlineSessionDate"

export function Headline({
    onlineOrOffline,
    onlineAndOfflineAvailable,
}: {
    onlineOrOffline?: OnlineOrOffline
    onlineAndOfflineAvailable: boolean
}) {
    return onlineOrOffline === "offline" ? (
        <HeadlineSessionDate className="mb-3">
            {onlineAndOfflineAvailable ? (
                <>Когда хотите провести личную сессию?</>
            ) : (
                <>Выберите время</>
            )}
        </HeadlineSessionDate>
    ) : (
        <HeadlineSessionDate className="mgb-3">
            {onlineAndOfflineAvailable ? (
                <>Когда хотите провести онлайн-сессию?</>
            ) : (
                <>Выберите время</>
            )}
        </HeadlineSessionDate>
    )
}
